import { Column } from "@/components/Datatable/types";
import { MyTrainingHistoryItem } from "../../api/fetchMyTrainingHistory/types";

export function myTrainingHistoryColumns(): Column<MyTrainingHistoryItem>[] {
  return [
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session Dates",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionDates,
    },
    {
      header: "Location",
      accessorKey: "locationName",
      enableSorting: true,
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Certificate",
      // The certificate-generation endpoint is not built yet (future ticket),
      // so present the affordance as disabled rather than linking to a URL
      // that would 404.
      accessorKey: "certificate",
      cell: ({ row }) =>
        row.original.certificate ? (
          <span
            className="cursor-not-allowed text-gray-400 dark:text-slate-500"
            title="Certificate download is not available yet"
          >
            Download (coming soon)
          </span>
        ) : (
          ""
        ),
    },
  ];
}
